export function filterByValue(arrayOfObjects, searchString, arrayOfKeys, allFields) {
    if (!Array.isArray(arrayOfObjects)) {
        return [];
    }
    const results = arrayOfObjects.filter(object => {
        let evaluateObject = object;
        //handle case of dynamic tables, filter on the displayed columns
        if (object.columns && object.data) {
            evaluateObject = object.columns;
        }

        return Object.keys(evaluateObject).some(key => {
            if (typeof evaluateObject[key] === 'string' && (allFields || arrayOfKeys?.includes(key))) {
                //This handles the case of HTML tags that begin with "<" and searches everything betweend till the end of the "> tag. It will remove everything between them."
                const cleanValue = evaluateObject[key].toLowerCase()?.replace(/(<([^>]+)>)/gi, "");
                return cleanValue?.includes(searchString.toLowerCase())
            }
            return null;
        })
    });
    return results;
}
// Splits the search on whitespace; every term must match at least one of the given keys,
// so a query can span multiple fields (e.g. "John Smith" or "Main St Springfield").
export function filterByTerms(arrayOfObjects, searchString, arrayOfKeys) {
    const terms = (searchString || '').toLowerCase().split(/\s+/).filter(Boolean);
    if (!Array.isArray(arrayOfObjects)) {
        return [];
    }
    if (terms.length === 0) {
        return arrayOfObjects;
    }
    return arrayOfObjects.filter(object => terms.every(term =>
        arrayOfKeys.some(key => {
            if (typeof object[key] !== 'string') {
                return false;
            }
            //Strip HTML tags (everything between "<" and ">") before matching, same as filterByValue
            const cleanValue = object[key].toLowerCase().replace(/(<([^>]+)>)/gi, "");
            return cleanValue.includes(term);
        })
    ));
}
